import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomButton from "../../components/CustomButton";
import Modal from './components/Modal';
import Api from "../../services/Api";
import {getLanguage} from "../../lang/helpers";


export default function SupportPage() {
  const api = Api.getInstance()
  const translation = useTranslation();
  const { t, i18n } = translation;
  const lang = getLanguage(i18n.language)

  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const onCloseModal = () => {
    setIsModalOpen(false);
  }

  const sendSupportTicket = () => {
    if (!description) {
      setErrorMessage(t('support-error-message'));
      return;
    }

    setIsLoading(true);
    setErrorMessage('');
    setIsModalOpen(true);

    const data = {
      description: description
    }
    api.post('client/support_ticket', data).then((response) => {
      setDescription('');
      setIsModalOpen(true);
      setIsLoading(false);
    }).catch(error => console.log(error))
  }

  return (
    <div className="main-content">
      <h1 className="z-heading1 text-white  my-4 desktop:my-6">
        {lang === 'sv' ? 'Hur kan vi hjälpa dig?' : 'How can we assist you?'}
      </h1>
      <p className="mt-2 text-gray-400">
        {lang === 'sv' ? 'Beskriv vad du vill ha hjälp med så återkommer vi så snart vi kan.' :
          'Let us know what you need help with, and we\'ll get back to you as soon as possible.'}
      </p>
      <div className="mt-6 gap-2 flex flex-col p-1">
        <div
          className="p-3 mb-4  h-40 items-center bg-indigo-1000 rounded-md ring-1 ring-indigo-700 focus-within:ring-2 focus-within:ring-primary-500">
          <textarea
            id="description"
            placeholder={lang === 'sv' ? 'Skriv här...' : 'Describe your issue here...'}
            className="w-full h-full flex-1 bg-indigo-1000 text-white px-4 py-3 rounded-md resize-none max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none"
            style={{whiteSpace: 'normal'}}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <CustomButton
          onClick={sendSupportTicket}
          className="w-full"
          disabled={!description && isLoading}
        >
          {isLoading ? t('support-sending') : t('send')}
        </CustomButton>
        <Modal isOpen={isModalOpen} onClose={onCloseModal}/>
        {errorMessage && <p className="mt-4 text-red-500">{errorMessage}</p>}
        <p className="mt-4 text-white">{t('support-email-info')}:</p>
        <p className="text-gray-400">support@zebrain.se</p>
      </div>
    </div>
  );
}